module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-d14bebcc182f772e63b5f8118aef065e.png";